<div class="mpp-radio-button__marker"></div>

<div class="mpp-radio-button__label" *ngIf="!labelTemplate && !boundLabel">
  <ng-content></ng-content>
</div>

<div class="mpp-radio-button__label" *ngIf="!labelTemplate && boundLabel">{{ boundLabel }}</div>

<ng-container *ngIf="labelTemplate" [ngTemplateOutlet]="labelTemplate"></ng-container>
